// Users allowed to use the Backfill feature (by email)
export const BACKFILL_ENABLED_USERS = new Set<string>([
  'biniyam@finchlegal.com',
  'moyez@finchlegal.com',
]);

export const isBackfillEnabledForUser = (userEmail?: string): boolean => {
  if (import.meta.env.VITE_APP_ENVIRONMENT === 'local') {
    return true;
  }
  if (!userEmail) return false;
  return BACKFILL_ENABLED_USERS.has(userEmail.toLowerCase());
};

// Users allowed to use the Treatment SMS feature (by email)
export const TREATMENT_SMS_ENABLED_USERS = new Set<string>([
  'faris@finchlegal.com',
  'mohamed@finchlegal.com',
  'mitul@finchlegal.com',
  'nailah@finchlegal.com',
  'sid@finchlegal.com',
  'thea@finchlegal.com',
  'viviana@finchlegal.com',
  'xipu@finchlegal.com',
]);

export const isTreatmentSmsEnabledForUser = (userEmail?: string): boolean => {
  // Always enable SMS in local/development environment
  if (import.meta.env.VITE_APP_ENVIRONMENT === 'local') {
    return true;
  }
  if (!userEmail) return false;
  return TREATMENT_SMS_ENABLED_USERS.has(userEmail.toLowerCase());
};

export const isRingCentralEnabledForUser = (_userEmail?: string): boolean => {
  return true;
};

export const isAgentV2EnabledForUser = (_userEmail?: string): boolean => {
  return true;
};

// Users allowed to use the Crashing Out tab (by email)
export const CRASHING_OUT_ENABLED_USERS = new Set<string>([
  'amit@finchlegal.com',
  'julia@finchlegal.com',
  'mitul@finchlegal.com',
  'rachel@finchlegal.com',
  'alicia.hunt@finchlegal.com',
  'julie.lopez@finchlegal.com',
  'julie@finchlegal.com',
  'jacqueline.maldonado@finchlegal.com',
  'jacqueline@finchlegal.com',
  'jaye@finchlegal.com',
  'admin@finchlegal.com',
]);

export const isCrashingOutEnabledForUser = (userEmail?: string): boolean => {
  if (import.meta.env.VITE_APP_ENVIRONMENT === 'local') {
    return true;
  }
  if (!userEmail) return false;
  return CRASHING_OUT_ENABLED_USERS.has(userEmail.toLowerCase());
};

const normalizeFinchEmail = (userEmail?: string): string | null => {
  if (!userEmail) return null;

  const normalized = userEmail.trim().toLowerCase();
  if (normalized.endsWith('@finchlegal')) {
    return `${normalized}.com`;
  }
  return normalized;
};

export const ALWAYS_SHOW_AGENT_COLUMN_USERS = new Set<string>([
  'rachel@finchlegal.com',
  'jaye@finchlegal.com',
  'alicia.hunt@finchlegal.com',
  'amit@finchlegal.com',
  'julia@finchlegal.com',
  'admin@finchlegal.com',
]);

export const isAgentColumnAlwaysVisibleForUser = (userEmail?: string): boolean => {
  const normalized = normalizeFinchEmail(userEmail);
  if (!normalized) return false;
  return ALWAYS_SHOW_AGENT_COLUMN_USERS.has(normalized);
};
